import React from 'react';
import { SampleRunStatus } from '../types';
import styles from '../MultiAnalysisPage.module.css';

const LABELS: Record<SampleRunStatus, string> = {
  pending: 'Pending',
  running: 'Running',
  valid: 'Valid',
  warning: 'Review',
  failed: 'Failed',
};

const CLASSES: Record<SampleRunStatus, string> = {
  pending: styles.pillPending,
  running: styles.pillRunning,
  valid: styles.pillValid,
  warning: styles.pillWarning,
  failed: styles.pillFailed,
};

type Props = {
  status: SampleRunStatus;
  reviewed?: boolean;
};

const StatusPill = ({ status, reviewed }: Props) => (
  <span className={`${styles.pill} ${CLASSES[status]}`}>
    {LABELS[status]}
    {reviewed ? ' ✓' : ''}
  </span>
);

export default StatusPill;
